import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  loginConfirmedAction,
  verifyAdminAction,
} from "../../../store/actions/AuthActions";
import logoFull from "../../../assets/images/rajdhani.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../assets/images/dod_logo.png";
import { FaArrowLeft } from "react-icons/fa6";
import OtpInput from 'react-otp-input';
import { CreatelogActivityApi, pass_systemIpAddress, systemIpAddress } from "../../../services/apis/IpAddress";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from 'react-device-detect';

function AdminVerificationTE(props) {
  const [email, setEmail] = useState();
  const location = useLocation()?.state;
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [otp, setOtp] = useState("");
  const [informationIp, setInformationIp] = useState({});
    const deviceType = {
      type: isMobile ? "Mobile" : isTablet ? "Tablet" : isDesktop ? "Desktop" : "Unknown",
      os: isAndroid ? "Android" : isIOS ? "iOS" : "Other"
    };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Validation logic
  const validateFields = () => {
    // OTP validation
    const errorObj = { otp: '' };
    let isError = false;

    if (!otp) {
      errorObj.otp = 'OTP is required';
      isError = true;
    } else if (!/^\d{6}$/.test(otp)) {
      errorObj.otp = 'OTP must be a 6-digit number';
      isError = true;
    }

    setErrors(errorObj);
    return isError;
  };

     // log activity-------------------------
    const SystemIp = async () => {
      try {
        await systemIpAddress()
          .then((response) => {
            passIpAddress(response?.data?.ip)
          })
      } catch (err) {
        console.log(err)
      }
    }
  
    const passIpAddress = async (ipv4) => {
      try {
        await pass_systemIpAddress(ipv4)
          .then((response) => {
            setInformationIp(response?.data)
          })
      } catch (err) {
        console.log(err)
      }
    }
  
    useEffect(() => {
      SystemIp();
    }, [])

    const loggedActivity = async (id) => {
      const data = {
        id:id,
        ipAddress: informationIp?.query,
        lat: informationIp?.lat,
        long: informationIp?.lon,
        logType:'login',
        deviceType: JSON.stringify(deviceType),
        city: informationIp?.city,
        countryCode: informationIp?.countryCode,
        regionCode: informationIp?.region
      }
      try {
        await CreatelogActivityApi(data)
      } catch (err) {
        console.log(err)
      }
    }

  function onLogin(e) {
    e.preventDefault();
    setSubmitted(true);
    // Validate fields
    if (validateFields()) {
      return;
    }
    const otpdata ={
      email:location?.email,
      otp:otp
    }
    // dispatch(loadingToggleAction(true));
    dispatch(verifyAdminAction(otpdata, navigate, loggedActivity));

    // const res = login(email, password, navigate);
    // console.log("response from login component");
    // if (res) {
    // 	navigate('/dashboard');
    // 	dispatch(loginConfirmedAction(res));

    // } else {
    // 	console.log("Login not successfully done");
    // }
  }

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="login-mainsection-background">
          <div className="container-fluid">
          <div className="row"> 
            <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
              <div className=" login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    {/* logo */}
                    <div className="d-flex justify-content-center mb-2">
                      <Link to={"/dashboard"}>
                        <img
                          src={TElogo}
                          alt="logo"
                          style={{ height: "80px", width: "auto" }}
                        />
                      </Link>
                    </div>
                    {/* Tag or intro Line */}
                    <h4 className="login-welcome-text">Authenticate Your Account</h4>
                    <p className="mb-4 fs-5 text-dark">Please confirm your account by entering the authorization code
                     send to <b>{location?.email}</b> it will expire in <b>6 minutes</b>.</p>

                    {/* Form */}
                    <form onSubmit={onLogin}>
                      <div className="mb-3">
                        <label className="mb-1 text-dark">
                          {/* <strong>OTP</strong> */}
                        </label>
                        <OtpInput
                          containerStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            maxWidth: '400px',
                            margin: '0 auto',
                          }}
                          inputStyle="otp-input-style"
                          inputType="number"
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          renderSeparator={<span className="text-white">-</span>}
                          renderInput={(props) => <input {...props} />}
                        />
                        {errors.otp && (
                          <div className="text-danger fs-12 mt-2">
                            {errors.otp}
                          </div>
                        )}
                      </div>
                      
                      <div className="d-flex gap-3 mt-4">
                        <button
                          type="button"
                          className="btn btn-light text-dark btn-block"
                          onClick={()=>navigate("/login")}>
                          Log Out
                        </button>
                                                
                        <button
                          type="submit"
                          className="btn text-white btn-block handle-login-btn">
                          Verify
                        </button>

                        {/* <button
                          type="submit"
                          className="btn text-white mt-3 px-0"
                          onClick={()=>navigate(-1)}>
                           <FaArrowLeft/> Go back
                        </button> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminVerificationTE;
